/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////
export { DEFAULT_PROPS } from './default-props';

/////////////////////////////////////////////
// COLOR CONFIGURATION
/////////////////////////////////////////////
export const BG_COLOR = {
  primary: 'rgba(13,51,40,1)',
  secondary: 'rgba(196,166,116,1)',
  tertiary: 'rgba(196,166,116,1)',
  alternative: '#F4F4F4',
};

export const TEXT_COLOR = {
  primary: 'rgba(237,193,130,1)',
  secondary: '#FFF',
  tertiary: 'rgba(167,142,85,1)',
  alternative: '#000',
};

export const ASSET_PATTERN_COLOR = 'rgba(196,166,116,1)';

export const NAVIGATION_COLOR = {
  base: TEXT_COLOR.tertiary,
  icon: TEXT_COLOR.alternative,
};

export const INPUT_COLOR = {
  background: '#ADABAC',
  color: TEXT_COLOR.tertiary,
};

export const DIVIDER_PATTERN_PROPS = {
  position: 'absolute',
  className: 'divider-pattern_cover',
  width: '100%',
  height: '110px',
  left: '0',
  overflow: 'hidden',
  zIndex: 0,
  opacity: '0.09',
};
